// removed by extract-text-webpack-plugin
module.exports = {"message":"error__message-1OXxI","animation":"error__animation-3GJcb","fadeIn":"error__fadeIn-1AMYu"};


//////////////////
// WEBPACK FOOTER
// ./components/auth/error/error.css
// module id = 788
// module chunks = 0